<template>
  <div class="col-12 ">

    <b-table
      v-if="revOrganos.revisiones.length > 0"
      :items="revOrganos.revisiones" 
      :fields="tableFields"
      class="text-center px-1 mt-1"
      responsive small
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>

    <div 
      v-if="revOrganos.revisiones.length > 0" 
      class="mt-2 px-1"
    >
      Observaciones: {{ revOrganos.observaciones ? revOrganos.observaciones : 'No registra observaciones' }}
    </div>
  </div>
</template>

<script>
import { anamnesisService } from '@/views/atencionMedica/services';

export default {

  name: "RevOrganosTable",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  

  created() {
    this.loadData();
  },


  data() {
    return {
      revOrganos: {
        revisiones: [],
        observaciones:''
      },

      tableFields: [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "revisionorganos.descripcion", 
          label: "Revision", 
          thClass: "text-left",
          tdClass: "text-left" 
        },
        { 
          key: "descripcionGeneral",       
          label: "descripcion",       
          thClass: "text-left",
          tdClass: "text-left"

        }
      ]
    }
  },

  methods: {
    async loadData() {
      if( !this.tokenAtencion ) return;

      this.revOrganos = await anamnesisService.getRevOrganosByAtencion(this.tokenAtencion);
    },

    emitHasData() {
      const hasData = this.revOrganos.revisiones.length > 0 || !!this.revOrganos.observaciones;
      this.$emit('input', hasData);
    }
  },

  watch: {
    tokenAtencion: {
      deep: true,
      handler: 'loadData'
    },

    revOrganos: {
      deep: true,
      handler() {
        this.emitHasData();
      }
    }
  }

}
</script>
